import { http } from './index';
import { ICheckParams} from '@types';

//查询修改的私教服务信息
export const getCourseDetail = (processId:number) => http.get(`/teaching-workbench/booking/v2/process/detail/${processId}`);

//获取老师近七天预约坐席
export const getSevenDaysAppointmentPlan = (data:{bookingId:number,teacherId:number }) => http.post('/teaching-workbench/booking/v2/seven-day/teacher/time',data);

//验证当前操作是否可选
export const checkAppointmentStatus = (data: ICheckParams) => http.post('/teaching-workbench/booking/v2/check/member/teacher/time', data);

//保存坐席
export const saveAppointmentStatus = (data: ICheckParams) => http.post('/teaching-workbench/booking/v2/save/modify/teacher/time', data);
